import React from "react";
import { SignIn } from "@clerk/clerk-react";

const PAPER = "#FFFEF9";

const clerkAppearance = {
  variables: {
    colorPrimary: "#C45C4A",
    colorBackground: PAPER,
    colorText: "#1A1A1A",
    colorTextSecondary: "#6B6B6B",
    colorInputBackground: "#FFFFFF",
    colorInputText: "#1A1A1A",
    colorNeutral: "#1A1A1A",
    borderRadius: "0.75rem",
    fontFamily: "inherit",
  },
  elements: {
    rootBox: "w-full max-w-none",
    cardBox: "w-full max-w-none shadow-none border-0 bg-transparent",
    card: "w-full max-w-none shadow-none border-0 bg-transparent p-0 gap-4",
    header: "hidden",
    headerTitle: "hidden",
    headerSubtitle: "hidden",
    main: "w-full gap-4",
    socialButtonsRoot: "w-full",
    socialButtons: "w-full gap-2",
    socialButtonsBlockButton: "w-full justify-center bg-white",
    dividerRow: "w-full",
    form: "w-full",
    formFieldRow: "w-full",
    formFieldLabelRow: "w-full",
    formFieldLabel: "text-ink",
    formFieldInput: "w-full bg-white",
    formButtonPrimary:
      "w-full bg-rouge hover:opacity-90 text-white shadow-none",
    footer: "w-full bg-transparent border-t border-line pt-4 mt-2",
    footerAction: "w-full justify-center bg-transparent",
    footerActionText: "text-mute",
    footerActionLink: "text-rouge",
    footerPages: "w-full bg-transparent justify-center",
    footerPagesLink: "text-mute",
  },
};

export default function LoginPage() {
  return (
    <div className="min-h-screen grid place-items-center bg-cream px-4 py-10">
      <div className="w-full max-w-[400px]">
        <div className="w-full overflow-hidden rounded-xl border border-line bg-paper px-6 pt-8 pb-5">
          <div className="mb-6 text-center">
            <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-rouge shadow-rouge">
              <span className="font-display text-xl font-bold leading-none text-white">
                V
              </span>
            </div>
            <h1 className="font-display text-2xl font-bold tracking-tight text-ink">
              MmeValentine
            </h1>
            <p className="mt-1 font-sans text-sm text-mute">
              Activation LinkedIn par IA
            </p>
            <p className="mt-3 font-sans text-sm text-ink/70">
              Connectez-vous pour continuer
            </p>
          </div>

          <div className="clerk-auth w-full">
            <SignIn
              routing="hash"
              signUpUrl="/register"
              forceRedirectUrl="/"
              appearance={clerkAppearance}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
